var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"journal",class:{ 
    faded: _vm.faded,
    selected: _vm.selected,
    fadein: _vm.fadein,
  },attrs:{"id":_vm.slug}},[_c('a',{staticClass:"name",class:{ 
      hovered: _vm.hovered,
    },on:{"mouseover":_vm.hoverinJournal,"mouseleave":_vm.hoveroutJournal,"click":_vm.clickJournal}},[(_vm.selected)?_c('span',{staticClass:"bullet"},[_vm._v("✕")]):_c('span',{staticClass:"bullet"},[_vm._v("⤷")]),_c('span',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm.moment( _vm.date ).format('MMM Do, YYYY'))+" ")])]),(_vm.selected)?_c('vue-markdown',{staticClass:"body",attrs:{"source":_vm.body}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }